import Table from 'components/Common/StyledTable';
import routes from 'constants/routes';
import { useNavigate } from 'react-router-dom';

const columns = [
    { id: 'name', label: 'Name' },
    { id: 'archdiocese', label: 'Archdiocese' },
    { id: 'location', label: 'Location' },
    // { id: 'status', label: 'Status' },
    // { id: 'contact', label: 'Contact' },
];

function AtlantaParishes({ data, loading }: { data: any; loading: boolean }) {
    const navigate = useNavigate();

    const navigationHandler = (row: any) => {
        navigate(routes.parishes.organizationDetails.replace(':companyId', row.companyId));
    };

    return (
        <div>
            <Table
                unStyled
                data={data}
                columns={columns}
                totalCount={data?.length}
                navigationHandler={navigationHandler}
                loading={loading}
            />
        </div>
    );
}

export default AtlantaParishes;
